// extracted by mini-css-extract-plugin
module.exports = {"iconsWrapper":"CalendarEvent_iconsWrapper__3bzgw","pendingPaymentIcon":"CalendarEvent_pendingPaymentIcon__WbcOV","gfeWrapper":"CalendarEvent_gfeWrapper__2PtuH"};